module.exports = __webpack_public_path__ + "img/bg.d6aedc56.png";